import React, { Component } from "react";
import PropTypes from "prop-types";

import "./VideoPlayer.css";
import Modal from '../modalReact/Modal';
import {Actions, SendAction} from "../../utility/Utils";
class VideoPlayer extends Component {

    constructor() {
        super ();
        this.state = {
            hover: false,
            maxMetaData: 10,
            metaData: [],
            currentMetaData: [],
            currentMetaDataTime: 0,
            products: [],
            product: {},
            showModal: false,
            paused: false
        }

    }

    componentDidMount() {
        this.initVideo();
        this.setState({ products: this.props.products, data: this.props.data });
    }

    componentDidUpdate(prevProps) {
        // Change player src when props change
        if (this.props.videoStream !== prevProps.videoStream) {
            this.player.src(this.props.videoStream);
        }
    }

    componentWillUnmount() {
        this.destroyVideo();
    }

    destroyVideo() {
        if (this.player) {
            this.player.dispose();
            this.player = null;
        }
    }

    initVideo() {

        //const PlayerState = IVSPlayer.PlayerState;
        //const PlayerEventType = IVSPlayer.PlayerEventType;

        // Here, we load videojs, IVS tech, and the IVS quality plugin
        // These must be prefixed with window. because they are loaded to the window context
        // in web-ui/public.
        const videojs = window.videojs,
            registerIVSTech = window.registerIVSTech,
            registerIVSQualityPlugin = window.registerIVSQualityPlugin;

        // Set up IVS playback tech and quality plugin
        if (registerIVSTech && registerIVSQualityPlugin) {
            registerIVSTech(videojs);
            registerIVSQualityPlugin(videojs);
        }

        const videoJsOptions = {
            techOrder: ["AmazonIVS"],
            autoplay: true,
            muted: this.props.muted,
            controlBar: {
                pictureInPictureToggle: false,
            },
        };

        // instantiate video.js
        this.player = videojs("amazon-ivs-videojs", videoJsOptions);
        this.player.ready(this.handlePlayerReady);
        // expose event for other components using it
        this.player.ready(this.props.onPlay);


        const events = this.player.getIVSEvents();
        const ivsPlayer = this.player.getIVSPlayer();

        const { partner, videoId} = this.props;

        // Attach event listeners
        ivsPlayer.addEventListener(events.PlayerState.PLAYING, function () {
            console.log("Player State - PLAYING");
            SendAction(partner, videoId, Actions.Play, "");
        });
        ivsPlayer.addEventListener(events.PlayerState.ENDED, function () {
            console.log("Player State - ENDED");
            SendAction(partner, videoId, Actions.End, "");
        });
        ivsPlayer.addEventListener(events.PlayerState.READY, function () {
            console.log("Player State - READY");
            SendAction(partner, videoId, Actions.Start, "");
        });
        ivsPlayer.addEventListener(events.PlayerState.IDLE, function () {
            console.log("Player State - IDLE or PAUSED");
            SendAction(partner, videoId, Actions.Pause, "");
        });
        ivsPlayer.addEventListener(events.PlayerEventType.ERROR, function (err) {
            console.warn("Player Event - ERROR:", err);
        });

        ivsPlayer.addEventListener(events.PlayerEventType.DURATION_CHANGED, function (err) {
            console.warn("Player Event - DURATION_CHANGED:", err);
        });

        ivsPlayer.addEventListener(events.PlayerEventType.IDLE, function (err) {
            console.warn("Player Event - IDLE:", err);
        });

        ivsPlayer.addEventListener(events.PlayerEventType.TEXT_METADATA_CUE, (cue) => {
            const metadataText = JSON.parse(cue.text);
            // this.props.setMetadataId(productId);
            const metadataTime = ivsPlayer.getPosition().toFixed(2);

            // insert new metadata
            //  metaData.unshift(`productId: ${productId} (${metadataTime}s)`);
            if (Array.isArray(metadataText)) {
                this.setState({currentMetaData: metadataText, currentMetaDataTime: metadataTime });
            }

        });
    }

    handlePlayerReady = () => {
        this.player.enableIVSQualityPlugin();
        this.player.src(this.props.videoStream);
        this.player.play();
        const selfi = this;
        this.player.on('timeupdate', function(time) {
            selfi.setState({currentMetaDataTime: this.currentTime().toFixed(2) });
        });

        this.player.on("pause", function () {
            selfi.setState({ paused: true });
        })

        this.player.on("play", function () {
            selfi.setState({ paused: false });
        })
    };

    handleVideoHover = () => {
        this.setState({ hover: true });
    }

    handleVideoUnHover = () => {
        this.setState({ hover: false });
    }

    onMouseMove = (e) => {
        const ivsPlayer = this.player.getIVSPlayer();

        const metadataTime = ivsPlayer.getPosition().toFixed(2);

        const {showModal } = this.state;
        const {fps, data, products, setMetadataId } = this.props;

        if (data) {

            let number = Math.round(metadataTime * fps);
            const currentMetaData = data[number]

            const y = (e.nativeEvent.offsetY / e.currentTarget.offsetHeight).toFixed(3);
            const x = (e.nativeEvent.offsetX / e.currentTarget.offsetWidth).toFixed(3);

            console.log("frame:" , number, " time:" , metadataTime, " fps: ", fps)
            console.log("x:" , x, "y:" , y)

            let metaData = ""
            let product = {}

            if (!showModal && currentMetaData != undefined) {
                for (let i = 0; i < currentMetaData.length; i++) {
                    const data = currentMetaData[i];
                    let minWeight = Number.MAX_SAFE_INTEGER;
                    if (data.x1 <= x && x <= data.x2 && data.y1 <= y && y <= data.y2) {
                        let area = Math.abs((data.x2-data.x1) * (data.y2-data.y1));
                        if ( area < minWeight) {
                            metaData = data.track_id; // (${currentMetaDataTime}s)
                            product = products.find(product => product.id === data.track_id)
                            minWeight = area
                        }
                    }
                }
                setMetadataId(metaData)
                metaData = "productId: " + metaData;
                this.setState({ metaData: metaData.length == 0 ? [] : [metaData], product: product == undefined ? {} : product, currentMetaData });
            }
        }


        this.setState({ x: e.nativeEvent.offsetX, y: e.nativeEvent.offsetY });
    }

    onMouseDown = (e) => {
        const { partner, videoId } = this.props;
        const { currentMetaData, product } = this.state;
        const y = (e.nativeEvent.offsetY / e.currentTarget.offsetHeight).toFixed(3);
        const x = (e.nativeEvent.offsetX / e.currentTarget.offsetWidth).toFixed(3);


        currentMetaData.forEach(metaData => {
            if (metaData.x1 <= x && x <= metaData.x2 && metaData.y1 <= y && y <= metaData.y2 && Object.keys(product).length > 0) {
                //this.setState({ metaData: [`productId: ${metaData.track_id} (${currentMetaDataTime}s)`] });
                this.setState({ showModal: true });
                this.player.pause();
                // this.props.setShowModal(true)
                SendAction(partner, videoId, "view", metaData.track_id);
            }
        })

        this.setState({ x: e.nativeEvent.offsetX, y: e.nativeEvent.offsetY });
    }

    renderMetaData = () => {
        const { metaData } = this.state;
        const className = "video-metadata-item" +  (this.player && this.player.isFullscreen() ? "-full" : "");
        const containerClassName = "video-metadata-container" + ( this.player && this.player.isFullscreen() ? "-full" : "");
        const metaDataItems = metaData.map(element => (
            <div className={className} key={element}>{element} </div>
        ));
        return (
            <div className={containerClassName + " pd-x-1 pd-y-05 pos-absolute bg-inverted br-all-sm color-inverted"}>
                {metaDataItems}
            </div>
        )
    }

    renderMetaData2 = () => {
        const {  products, currentMetaDataTime, paused } = this.state;

        const {fps, data } = this.props;

        let currentMetaData = []
        if (data && paused) {

            let number = Math.round(currentMetaDataTime * fps);
            currentMetaData = data[number]
        }

        const metaDataItems = currentMetaData.map(element => {
            const left  = Math.round(((parseFloat(element["x1"]) + parseFloat(element["x2"])) / 2)  * 100)
            const top = Math.round(((parseFloat(element["y1"]) + parseFloat(element["y2"])) / 2)  * 100)
            const product = products && products.find(product => product.id === element.track_id)
            const linkUrl = product && product["linkUrl"]

            return (
                //  <a href={linkUrl} className="sercan btn btn-primary animate-ping white-dot absolute inline-flex h-full w-full rounded-full bg-white opacity-90" style={{top: top+"%", left: left + "%",  zIndex: 999}}>{element["track_id"] }</a>
                <a href={linkUrl} className="pin" style={{top: top+"%", left: left + "%",  zIndex: 999, fontSize: '14px'}}>{element["track_id"] }</a>
            )
        });

        return (
            <div >
                {paused && metaDataItems}

            </div>
        )




    }

    closeModal = () => {
        this.setState({showModal: false, metaData: ["Thanks for trying our demo!"]});
    }

    render() {
        const { product, products, showModal} = this.state;

        const { imageUrl, currency, partner, videoId } = this.props;
        return (
            <div className="video-container pos-relative">
                <div className="aspect-169 pos-relative full-width full-height"
                     onMouseEnter={this.handleVideoHover}
                     onMouseLeave={this.handleVideoUnHover}
                     onMouseMove={this.onMouseMove}
                     onMouseDown={this.onMouseDown}
                     data-vjs-player>
                    { this.renderMetaData()}

                    <video
                        id="amazon-ivs-videojs"
                        className="video-js vjs-fluid vjs-big-play-centered"
                        controls={this.props.controls}
                        playsInline
                    ></video>
                    {showModal && Object.keys(product).length > 0 && (
                        <Modal product={product} closeModal={this.closeModal} products={products} imageApiUrl={imageUrl} currency={currency}
                               partner={partner} videoId={videoId}/>
                    )}
                </div>
            </div>
        );
    }
}

VideoPlayer.propTypes = {
    videoStream: PropTypes.string,
    controls: PropTypes.bool,
    muted: PropTypes.bool,
    onPlay : PropTypes.func,
    setShowModal: PropTypes.func,
};

export default VideoPlayer;
